<template>
    <div>
        <p class="title">申请人信息</p>
        <van-cell-group>
            <van-field label="申请人" :value="this.$cookie.getUser().realName" readonly input-align="right"/>
            <van-field label="身份证号码"
                       :value="this.$cookie.getUser().idNum.replace(/^(\d{3})\d{10}(\d+)/, '$1**********$2')" readonly
                       input-align="right"/>
            <van-field required label="联系电话" v-model="phone" placeholder="请输入联系电话" clearable input-align="right"/>
            <van-field required label="联系地址" type="textarea" v-model="address" placeholder="请输入联系地址" rows="1" autosize
                       clearable input-align="right"/>
        </van-cell-group>
    </div>
</template>

<script>
    /**
     * Description: 申请人信息
     * Author: wangyan
     * Date: 2019-04-30
     * Time: 15:07
     */

    import {CellGroup, Field} from "vant";

    export default {
        name: "BasicInformation",
        components: {
            [CellGroup.name]: CellGroup,
            [Field.name]: Field
        },
        props: {
            userInfo: {
                type: Object,
                default: () => ({})
            },
            declareInfo: {
                type: Object,
                default: () => ({})
            },
            informationShowData: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                name: '',
                idNum: '',
                address: '',
                phone: ''
            }
        },
        watch: {
            userInfo: {
                handler(val) {
                    if (val) {
                        this.name = val.realName
                        this.idNum = val.idNum
                        this.address = val.fullAddress
                        this.phone = val.telephone
                    }
                },
                deep: true
            }
        },
        methods: {
            setBasicInfo() {
                this.declareInfo.linkAddress = this.address
                this.declareInfo.linkPhone = this.phone
                this.informationShowData.name = this.name
                this.informationShowData.idNum = this.idNum
                this.informationShowData.address = this.address
                this.informationShowData.phone = this.phone
            }
        }
    }
</script>

<style lang="less" scoped>
    .title {
        padding: 0.3rem;
        color: #808080;
    }
</style>
